import { Link } from '@tanstack/react-router';

/** The landing page's close. The three audiences and their addresses live on
 *  /contact now; repeating them here would mean maintaining the same three
 *  cards in two places and asking the reader to choose twice. */
export function Contact() {
  return (
    <section className="cta" id="contact">
      <h2 className="cta__title">Any robot.<br /><span className="grad">Any vendor.</span><br />One floor.</h2>

      <p className="cta__sub">
        Tell us what is already on your floor and we will tell you what can share it.
      </p>

      <Link className="duo__btn cta__btn" to="/contact">
        Start a conversation<span aria-hidden="true">↗</span>
      </Link>
    </section>
  );
}
